module.exports = __webpack_public_path__ + "img/f6a922f2df27759ff3f1942547559bb4.png";